import z from 'zod';
import { RoutingRuleTriggerType } from '@mews-commander/data-access';

export enum RoutingRulesListFilterSchemaKeys {
    Name = 'name',
    Timing = 'timing',
    Companies = 'companies',
    TravelAgencies = 'travelAgencies',
    Rates = 'rates',
    GuestProfiles = 'guestProfiles',
    Groups = 'groups',
    Reservations = 'reservations',
}
export const routingRulesListFilterSchema = z
    .object({
        [RoutingRulesListFilterSchemaKeys.Name]: z.string(),
        [RoutingRulesListFilterSchemaKeys.Timing]: z.array(z.nativeEnum(RoutingRuleTriggerType)).min(1),
        // companies and travelAgencies can be only string[] when FeatureFlag.granularRoutingRulesConditionsExtensionEnabled is done
        [RoutingRulesListFilterSchemaKeys.Companies]: z.string().or(z.array(z.string())).nullable(),
        [RoutingRulesListFilterSchemaKeys.TravelAgencies]: z.string().or(z.array(z.string())).nullable(),
        [RoutingRulesListFilterSchemaKeys.Rates]: z.array(z.string()).nullable(),
        [RoutingRulesListFilterSchemaKeys.GuestProfiles]: z.array(z.string()).nullable(),
        [RoutingRulesListFilterSchemaKeys.Groups]: z.array(z.string()).nullable(),
        [RoutingRulesListFilterSchemaKeys.Reservations]: z.array(z.string()).nullable(),
    })
    .partial();

export const routingRulesListUrlFilterSchema = z.optional(routingRulesListFilterSchema);

export type RoutingRulesListFilterValues = z.infer<typeof routingRulesListFilterSchema>;
